import React, { createContext, ReactNode, useState } from "react";

interface Props {
  children: ReactNode;
}

interface ImageContextProps {
  filesContext: { [key: string]: FileList | any };
  setFilesContext: React.Dispatch<React.SetStateAction<FileList | object>>;
}

export const ImageContext = createContext<ImageContextProps>({
  filesContext: {},
  setFilesContext: () => {},
});

export const ImageStore: React.FC<Props> = ({ children }) => {
  const [filesContext, setFilesContext] = useState<object | any>({});

  return (
    <ImageContext.Provider value={{ filesContext, setFilesContext }}>
      {children}
    </ImageContext.Provider>
  );
};
